// extracted by mini-css-extract-plugin
export default {"sale-info":"styles__sale-info--HGaeS","sale-date":"styles__sale-date--U6zNi"};